var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.77 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.39,7.52c-1.75,0-3.17-1.42-3.17-3.17v-1.18c0-1.75,1.42-3.17,3.17-3.17s3.17,1.42,3.17,3.17v1.18c0,1.75-1.42,3.17-3.17,3.17Z",
    fill: "#ef5323",
    fillRule: "evenodd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.59,8.19h3.59c1.98,0,3.59,1.61,3.59,3.59v.22H0v-.22c0-1.98,1.61-3.59,3.59-3.59Z",
    fill: "#ef5323",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.cbb24c3eb4fb92ba34e5089b4c74cb9c.svg";
export { ForwardRef as ReactComponent };